import React from 'react';
import PropTypes from 'prop-types';
import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';

const InfoCircleFillIcon = ({
  className,
  color,
  onClick,
  size,
}) => (
  <WithIconRounded
    className={className}
    onClick={onClick}
  >
    <svg
      fill="none"
      height={size}
      viewBox="0 0 12 12"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12C9.3137 12 12 9.3137 12 6C12 2.68629 9.3137 0 6 0C2.68629 0 0 2.68629 0 6C0 9.3137 2.68629 12 6 12ZM6.5 3.5C6.5 3.77615 6.27615 4 6 4C5.72385 4 5.5 3.77615 5.5 3.5C5.5 3.22385 5.72385 3 6 3C6.27615 3 6.5 3.22385 6.5 3.5ZM6 5C6.27615 5 6.5 5.22385 6.5 5.5V8C6.77615 8 7 8.22385 7 8.5C7 8.77615 6.77615 9 6.5 9H5.5C5.22385 9 5 8.77615 5 8.5C5 8.22385 5.22385 8 5.5 8V5.5C5.5 5.22385 5.72385 5 6 5Z"
        fill={color}
      />
    </svg>
  </WithIconRounded>
);

InfoCircleFillIcon.defaultProps = {
  className: 'icon-text',
  color: 'var(--k-ds-color-blue-500)',
  onClick: null,
  size: 16,
};

InfoCircleFillIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.number,
};

export default InfoCircleFillIcon;
